import React from 'react';
import PropTypes from 'prop-types';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import {IconButton} from "@material-ui/core";
import css from './GpsCenterControl.module.css';

const GpsCenterControl = (props) => {
	return (
		<div className={css.Button}>
			<IconButton onClick={props.onClick}><GpsFixedIcon /></IconButton>
		</div>
	);
};

GpsCenterControl.propTypes = {
	onClick: PropTypes.func.isRequired
};

export default GpsCenterControl;